import { NumberField } from "@imi-ernd-be/hyselect-engine";
import { assert, isObject } from "radashi";
import { isPhysicalType, PhysicalType } from "../../units/constants";

export type NumberFieldDefinition = {
  default: number | null;
  disabled: boolean;
  max: number;
  maxDecimal: number | null;
  min: number;
  physicalType: PhysicalType | null;
  translationKey: string;
  type: "number";
  valueSI: number;
};

export function getNumberDefinition(
  field: NumberField | null,
): NumberFieldDefinition {
  assert(field, "NumberField is null in getNumberDefinition");
  return {
    default: field.default,
    disabled: field.disabled,
    max: field.max,
    maxDecimal: field.maxDecimal >= 0 ? field.maxDecimal : null,
    min: field.min,
    physicalType: isPhysicalType(field.physicalType)
      ? field.physicalType
      : null,
    translationKey: field.translationKey,
    type: "number",
    valueSI: field.valueSI,
  };
}

export function isNumberDefinition(
  definition: unknown,
): definition is NumberFieldDefinition {
  if (!isObject(definition)) return false;
  const def = definition as Record<string, unknown>;

  return (
    def.type === "number" &&
    (typeof def.default === "number" || def.default === null) &&
    typeof def.disabled === "boolean" &&
    typeof def.max === "number" &&
    (typeof def.maxDecimal === "number" || def.maxDecimal === null) &&
    typeof def.min === "number" &&
    (typeof def.physicalType === "string" || def.physicalType === null) &&
    typeof def.translationKey === "string"
  );
}
